import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * ColumnVisibilityDropdown
 * Generic show/hide checkbox panel for a set of toggleable columns.
 * Not table-specific - callers own the column list and the hidden-key set.
 */
const ColumnVisibilityDropdown = ({ columns, hidden, onToggle }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div className="dropdown" ref={containerRef}>
      <button
        type="button"
        className="btn btn-secondary btn-small dropdown-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {t('clientQuotes.toggleColumnsButton')}
      </button>

      {isOpen && (
        <div className="dropdown-panel">
          {columns.map((column) => (
            <label key={column.key} className="dropdown-item">
              <input
                type="checkbox"
                checked={!hidden.has(column.key)}
                onChange={() => onToggle(column.key)}
              />
              {column.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnVisibilityDropdown;
